import { useState } from "react";
import {
  copyToClipboard,
  downloadFile,
  safeFilename,
  toMarkdown,
  toPlainText,
  type ExportInput,
} from "../utils/export";

export function DownloadActions({ input }: { input: ExportInput }) {
  const [toast, setToast] = useState<string | null>(null);
  function showToast(msg: string) {
    setToast(msg);
    setTimeout(() => setToast(null), 1600);
  }

  return (
    <div
      className="row"
      role="group"
      aria-label="Export results"
      style={{ justifyContent: "flex-end" }}
    >
      <span
        style={{
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.12em",
          color: "var(--text-dim)",
          textTransform: "uppercase",
          marginRight: "auto",
        }}
      >
        Save the result
      </span>
      <button
        className="btn"
        data-testid="copy-all"
        onClick={async () => {
          if (await copyToClipboard(toPlainText(input))) {
            showToast("Copied to clipboard.");
          }
        }}
      >
        ⎘ COPY ALL
      </button>
      <button
        className="btn"
        data-testid="download-txt"
        onClick={() => {
          downloadFile(safeFilename(input.prompt, "txt"), toPlainText(input), "text/plain");
          showToast("Text file downloaded.");
        }}
      >
        ⬇ TEXT
      </button>
      <button
        className="btn"
        data-testid="download-md"
        onClick={() => {
          downloadFile(
            safeFilename(input.prompt, "md"),
            toMarkdown(input),
            "text/markdown",
          );
          showToast("Markdown file downloaded.");
        }}
      >
        ⬇ MARKDOWN
      </button>
      {toast && <span className="toast">{toast}</span>}
    </div>
  );
}
